export default __webpack_public_path__ + "static/magnite-aa15a3eb11714d0452ff1880486b45f3.svg";